// extracted by mini-css-extract-plugin
export default {"root":"root---jF2Gf","content":"content---Clxft","icon":"icon---CKvvB","open":"open---f5bCa","button":"button---JqCU5"};